<template>
  <Dialog
    :visible="visible"
    modal
    :header="t('buttons.exportCSV')"
    :style="{ width: '50vw' }"
    @update:visible="onVisibleChange"
  >
    <slot :dataKey="dataKey" />
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from 'primevue/dialog';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineProps<{
  visible: boolean;
  dataKey?: string;
}>();

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void;
}>();

const onVisibleChange = (newValue: boolean) => {
  emit('update:visible', newValue);
};
</script>
